/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Crosspostingtypeposthint3Inputs */

const en_crosspostingtypeposthint3 = /** @type {(inputs: Crosspostingtypeposthint3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Text, images, and an optional link (Facebook).`)
};

const de_crosspostingtypeposthint3 = /** @type {(inputs: Crosspostingtypeposthint3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Text, Bilder und optional ein Link (Facebook).`)
};

/**
* | output |
* | --- |
* | "Text, images, and an optional link (Facebook)." |
*
* @param {Crosspostingtypeposthint3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const crosspostingtypeposthint3 = /** @type {((inputs?: Crosspostingtypeposthint3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Crosspostingtypeposthint3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_crosspostingtypeposthint3(inputs)
	return de_crosspostingtypeposthint3(inputs)
});
export { crosspostingtypeposthint3 as "crosspostingTypePostHint" }